import * as GtmService from './gtm';

GtmService.initialize();

export { GtmService };
